"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const mediaGroup_1 = __importDefault(require("../mediaGroup"));
const index_1 = __importDefault(require("../document/index"));
const jobItemGroup_1 = __importDefault(require("../jobItemGroup"));
const note_1 = __importDefault(require("../note"));
const action_1 = __importDefault(require("../action"));
const message_1 = __importDefault(require("../message"));
const signature_1 = __importDefault(require("../signature"));
// eslint-disable-next-line no-redeclare
class DocumentItem extends complexData_1.default {
    static get allowedAssociations() {
        return {
            media: {
                key: 'mediaGroup',
                instance: mediaGroup_1.default,
                single: true,
                condition: {
                    $or: [
                        { [this.Entity.getFieldSymbols().type]: 'Media' },
                        { [this.Entity.getFieldSymbols().type]: 'Media-l' },
                        { [this.Entity.getFieldSymbols().type]: 'Media-m' },
                        { [this.Entity.getFieldSymbols().type]: 'Media-fp' },
                    ],
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
            document: {
                key: 'document',
                instance: index_1.default,
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().document_id,
                },
            },
            jobItemGroup: {
                key: 'jobItemGroup',
                instance: jobItemGroup_1.default,
                single: true,
                condition: {
                    [this.Entity.getFieldSymbols().type]: 'JobItem',
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
            note: {
                key: 'note',
                instance: note_1.default,
                single: true,
                condition: {
                    [this.Entity.getFieldSymbols().type]: 'Note',
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
            action: {
                key: 'action',
                instance: action_1.default,
                single: true,
                condition: {
                    [this.Entity.getFieldSymbols().type]: 'Action',
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
            message: {
                key: 'message',
                instance: message_1.default,
                single: true,
                condition: {
                    [this.Entity.getFieldSymbols().type]: 'Message',
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
            signature: {
                key: 'signature',
                instance: signature_1.default,
                single: true,
                condition: {
                    [this.Entity.getFieldSymbols().type]: 'Signature',
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            media: true,
            note: true,
            jobItemGroup: true,
        };
    }
    async getLinkedItem() {
        const linkedAssociationName = this.getTypeAssociationName();
        return (await this.getAssociatedValue(linkedAssociationName))[0];
    }
    getTypeAssociationName() {
        return Object.keys(this.constructor.allowedAssociations).find(associationName => {
            const currentAssociation = this.constructor.allowedAssociations[associationName];
            if (currentAssociation.condition && Array.isArray(currentAssociation.condition.$or)) {
                return currentAssociation.condition.$or.some((value) => value[DocumentItem.Entity.getFieldSymbols().type] === this.data.type);
            }
            return currentAssociation.condition && currentAssociation.condition[DocumentItem.Entity.getFieldSymbols().type] === this.data.type;
        });
    }
}
DocumentItem.Entity = entity_1.default;
DocumentItem.modelProperties = modelProperties_1.default;
exports.default = DocumentItem;
//# sourceMappingURL=../../../../src/models/documentItem/index.js.map